module.exports = __webpack_public_path__ + "static/screenshot1-68b15c7c04197780e8859c9101bc5423.png";